export default __webpack_public_path__ + "static/media/sublime fluted panel.e7066096.png";